/* eslint-disable */
export default {
  init() {
    // scripts here run on the DOM load event
    $(document).ready(function() {
        let item_data = JSON.parse(localStorage.getItem('item_data'));
        if(!jQuery.isEmptyObject(item_data)) {  //coming from the product page
          $('form textarea').html('Hi I’m interested in ' + item_data.num + ', ' + item_data.title + ', ' + item_data.link); 
          localStorage.removeItem('item_data');       
        } 
    }); 
  },
  finalize() {
    // scripts here fire after init() runs
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/contact.js